/**
 * 路由配置
 */
import NProgress from 'nprogress';
import type { _RouteLocationBase } from 'vue-router';
import { createRouter, createWebHistory } from 'vue-router';
import { WHITE_LIST, REDIRECT_PATH, LAYOUT_PATH } from '@/config/setting';
import { useUserStore } from '@/store/modules/user';
import { getToken, setToken } from '@/utils/token-util';
import { setPageTitle } from '@/utils/page-title-util';
import { getRouteTitle } from '@/i18n/use-locale';
import { routes, getMenuRoutes } from './routes';
import { StorageUtil } from '@/utils/lzd-util';

NProgress.configure({
  speed: 200,
  minimum: 0.02,
  trickleSpeed: 200,
  showSpinner: false
});

const router = createRouter({
  routes,
  history: createWebHistory(),
  scrollBehavior: () => {
    return { top: 0 };
  }
});

/**
 * 路由守卫
 */
router.beforeEach(async (to) => {
  /** 模拟登录 */
  const access_token = to.query.access_token;
  if (typeof access_token === 'string' && access_token) {
    setToken(access_token);
    location.replace('/');
    return;
  }
  if (!to.path.includes(REDIRECT_PATH)) {
    NProgress.start();
    setPageTitle(getRouteTitle(to));
  }
  if (!getToken()) {
    // 未登录跳转登录界面
    // if (!WHITE_LIST.includes(to.path)) {
    if (WHITE_LIST.includes(to.path)) {
      return;
    }
    if (!/^\/\w+$/i.test(to.path)) {
      // const query = { from: encodeURIComponent(to.fullPath) };
      const query = { tenantId: StorageUtil.get('currTenantId') };
      return { path: '/login', query: to.path === LAYOUT_PATH ? {} : query };
    }
    return;
  }
  // 注册动态路由
  const userStore = useUserStore();
  if (!userStore.menus) {
    const { menus, homePath } = await userStore.fetchUserInfo();
    if (menus) {
      getMenuRoutes(menus, homePath).forEach((r) => {
        router.addRoute(r);
      });
      // 学生 直接重定向
      if (userStore?.info?.category === 0 && to.path === '/') {
        router.replace('/bsl/project/student/task/list');
        return;
      }
      return { ...to, replace: true };
    }
  }
});

router.afterEach((to) => {
  if (!to.path.includes(REDIRECT_PATH) && NProgress.isStarted()) {
    setTimeout(() => {
      NProgress.done(true);
    }, 200);
  }
});

export default router;
